import { Typography } from '@material-ui/core'

import SectionTitle from '../../components/SectionTitle'
import UploadSingleFile from '../../components/UploadSingleFile'
import { getTranslate } from '../../localization'
import { SiteKeyUpload } from '../../types/sitekey'
import useStyles from './styles/SitekeyLogoUpload.styles'

interface SitekeyLogoUploadProps {
  values: SiteKeyUpload
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  sitekeyId: string
}

const SitekeyLogoUpload: React.FC<SitekeyLogoUploadProps> = ({
  values,
  setFieldValue,
  sitekeyId
}) => {
  const classes = useStyles()

  return (
    <div>
      <div>
        <SectionTitle title={getTranslate('Upload Logo')} marginBottom />
      </div>
      <div className={classes.mainDiv}>
        <div className={classes.uploadBox}>
          <Typography>{getTranslate('Logo')}</Typography>
          <UploadSingleFile
            image={{
              fileURL: values.Logo.EN?.fileURL || '',
              file: values.Logo.EN?.file
            }}
            setImage={(data) => {
              setFieldValue('Logo.EN', data)
            }}
            sitekeyId={sitekeyId}
          />
        </div>
        <div className={classes.uploadBox}>
          <Typography>{getTranslate('Persian Logo')}</Typography>
          <UploadSingleFile
            image={{
              fileURL: values.Logo.FA?.fileURL || '',
              file: values.Logo.FA?.file
            }}
            setImage={(data) => {
              setFieldValue('Logo.FA', data)
            }}
            sitekeyId={sitekeyId}
          />
        </div>
        <div className={classes.uploadBox}>
          <Typography>{getTranslate('Favicon')}</Typography>
          <UploadSingleFile
            image={{
              fileURL: values.Favicon.EN?.fileURL || '',
              file: values.Favicon.EN?.file
            }}
            setImage={(data) => {
              setFieldValue('Favicon.EN', data)
            }}
            sitekeyId={sitekeyId}
          />
        </div>
        <div className={classes.uploadBox}>
          <Typography>{getTranslate('Persian Favicon')}</Typography>
          <UploadSingleFile
            image={{
              fileURL: values.Favicon.FA?.fileURL || '',
              file: values.Favicon.FA?.file
            }}
            setImage={(data) => {
              setFieldValue('Favicon.FA', data)
            }}
            sitekeyId={sitekeyId}
          />
        </div>
      </div>
    </div>
  )
}
export default SitekeyLogoUpload
